import { AuthContext } from "../App";
import { useContext, useState } from "react";
import Login from "./Login";
import { Drawer } from "@mui/material";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link } from "react-router-dom";
import useLogout from "../utils/useLogout";
import "./MenuBar.css";
import menuButton from "../assets/menu/menu-button.svg";

export default function MenuBar() {
  const { state } = useContext(AuthContext);
  const [loginOpen, setLoginOpen] = useState(false);
  const [btnText, setBtnText] = useState();

  
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const handleClick = (event) => {
    console.log(event);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [profileAnchorEl, setProfileAnchorEl] = useState(null);
  const profileOpen = Boolean(profileAnchorEl);
  const handleProfileClick = (event) => {
    if (state.isLogin) {
      setProfileAnchorEl(event.currentTarget);
    } else {
      setLoginOpen(true);
    }
  };
  const handleProfileClose = () => {
    setProfileAnchorEl(null);
  };

  const logout = useLogout();
  const handleLogout = () => {
    setProfileAnchorEl(null);
    logout();
  }

  const handleLoginClose = () => {
    setLoginOpen(false);
  }
  
  return (
    <div className="menu-bar flex justify-between">
      <div className="menu-button"><button onClick={handleClick}><img src={menuButton} /></button></div>
      <div className="profile text-white"><button onClick={handleProfileClick}>{state.isLogin?"个人中心":"登录"}</button></div>
      <Drawer
        anchor="bottom"
        open={loginOpen}
        onClose={handleLoginClose}
        sx={{
          "& .MuiDrawer-paper": {
            background: "black",
            borderRadius: "30px 30px 0px 0px"
          }
        }}
      > 
        <div className="login-container">
          <Login handler={handleLoginClose} />
        </div>
      </Drawer>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{
          "& .MuiPaper-root": {
            width: "110px"
          }
        }}
      >
        <MenuItem onClick={handleClose} sx={{ justifyContent: "center" }}><Link to="/">主页</Link></MenuItem>
        <MenuItem onClick={handleClose} sx={{ justifyContent: "center" }}><Link to="/about">关于</Link></MenuItem>
      </Menu>
      <Menu
        id="profile-menu"
        anchorEl={profileAnchorEl}
        open={profileOpen}
        onClose={handleProfileClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{
          "& .MuiPaper-root" :{
            width: "110px"
          }
        }}
      >
        <MenuItem onClick={handleProfileClose} sx={{ justifyContent: "center" }}><Link to="/mynft">我的NFT</Link></MenuItem>
        <MenuItem onClick={handleLogout} sx={{ justifyContent: "center" }}>退出登录</MenuItem>
      </Menu>
    </div>
  );
}
